import React from "react";
import { Link } from "react-router-dom";
import ChatTile from "../ChatTile/ChatTile";

interface ChatTilesContainerProps {
  chats: {
    id: string;
    chatTopic: string;
    chatText: string;
    creationDate: Date;
  }[];
}

function ChatTilesContainer({ chats }: ChatTilesContainerProps) {
  return (
    <div>
      {chats.map((chatTile) => (
        <Link
          to={`/chat/${chatTile.id}`}
          key={chatTile.id}
          style={{ textDecoration: "none" }}
        >
          <ChatTile
            id={chatTile.id}
            chatTopic={chatTile.chatTopic}
            chatText={chatTile.chatText}
            creationDate={chatTile.creationDate.toLocaleDateString("en-GB")}
          />
        </Link>
      ))}
    </div>
  );
}

export default ChatTilesContainer;
